
<div class="table-container mat-elevation-z8"> 
  <button mat-mini-fab (click)="ajouterNouveau()"  color="primary"><mat-icon>add</mat-icon></button> 
<table mat-table #table [dataSource]="dataSource"  style="    height: 80%;
overflow: auto;"  >
  <ng-container matColumnDef="nom">
    <th mat-header-cell *matHeaderCellDef> Nom </th>
    <td mat-cell *matCellDef="let row"> {{row.nom}} </td>
  </ng-container>

  <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef> Mobile </th>
      <td mat-cell *matCellDef="let row"> {{row.mobile}} </td>
    </ng-container>
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let row"> 
<button mat-icon-button (click)="select(row)" >dddddddddddddd<mat-icon>done_outline</mat-icon></button>
<button mat-icon-button (click)="deleteContact(row)" ><mat-icon>remove</mat-icon></button>


        </td>
      </ng-container>

  <tr mat-header-row *matHeaderRowDef="['nom','mobile','action']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['nom','mobile','action'];"></tr>
</table>
</div>
